module.exports = __webpack_public_path__ + "assets/img/thumb-Betashares-Video.3c46d9a3.jpg";